import { Input as AntdInput, InputNumber as AntdInputNumber } from 'antd'
import styled from '@emotion/styled'

export const Input = styled(AntdInput)`
  font-family: 'Prompt';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  padding: 10px 40px 10px 10px;
  border-radius: 8px;
`

export const Span = styled('span')`
  font-family: 'Prompt';
  color: rgb(186, 186, 186);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  position: absolute;
  right: 0;
  margin-top: 10px;
  padding-left: 2px;
  margin-right: 10px;
`
